import { createSlice } from '@reduxjs/toolkit'

import { fetchUserInfo } from '../user/thunks/fetchUserInfo'
import { groupsAdapter } from './groupsAdapter'
import { Group } from './models/Group'
import { saveGroup } from './thunks/saveGroup'
import { toggleGroupStatus } from './thunks/toggleGroupStatus'

export const initialGroupState = groupsAdapter.getInitialState()

export const groupsSlice = createSlice({
  name: 'groups',
  initialState: initialGroupState,
  reducers: {
    upsertMultipleGroups: (state, action) => {
      groupsAdapter.upsertMany(state, action.payload)
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveGroup.fulfilled, (state, action) => {
        groupsAdapter.upsertOne(state, action.payload)
      })
      .addCase(toggleGroupStatus.fulfilled, (state, action) => {
        const id = action.payload

        if (!id) return

        const group = state.entities[id]

        if (group) {
          group.isActive = !group.isActive
        }
      })
      .addCase(fetchUserInfo.fulfilled, (state, action) => {
        groupsAdapter.setAll(state, action.payload.groups as Group[])
      })
  },
})

export const { upsertMultipleGroups } = groupsSlice.actions
